import { teal } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import AboutSelect from '../../components/About/AboutSelect';
import ContactButton from '../../components/About/ContactButton';
import ChatWithUsDiscordButton from '../../components/About/ChatWithUsDiscordButton';
import FAQ from '../../components/About/FAQAccordion';
import Footer from '../../components/General/Footer';
import HeaderCard from '../../components/General/HeaderCard';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import withApollo from '../../lib/withApollo';
import Link from 'next/link';

const FaqPage = () => {
  const title = 'FAQ';
  return (
    <>
      <Header
        subheader={title}
        description="Everything you ever wanted to know about TravelFeed. Find out how to start your free travel blog!"
      />
      <Head title={`${title}`} />
      <AboutSelect selection={3} />
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        className="pt-4 pb-4"
      >
        <Grid item lg={7} md={8} sm={11} xs={12}>
          <HeaderCard
            title={title}
            background={teal[600]}
            content={
              <>
                <FAQ />
                <Typography gutterBottom variant="h5" className="pt-4">
                  More Questions?
                </Typography>
                <p className="highlightLinks">
                  Check out our <Link href="/help">Help Center</Link>!
                </p>
                <p>
                  We are happy to answer your questions and are waiting for your
                  message:
                </p>
                <ContactButton />
                <ChatWithUsDiscordButton />
              </>
            }
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default withApollo(FaqPage);
